import { Upsell, UpsellsResponse } from '@/@types/Upsell';
import { api } from './api';

async function listUpsells(
  productId: string,
  params?: { page?: number; perPage?: number },
): Promise<UpsellsResponse> {
  const response = await api.get(`/v1/products/${productId}/offer-funnels`, {
    params: {
      page: params?.page,
      per_page: params?.perPage,
    },
  });
  return response.data;
}

async function listUpsell(
  productId: string,
  upsellId: string
): Promise<Upsell> {
  const response = await api.get(
    `/v1/products/${productId}/offer-funnels/${upsellId}`
  );
  return response.data.data;
}

async function createUpsell({
  productId,
  data,
}: {
  productId: string;
  data: Omit<Upsell, 'id'>;
}): Promise<Upsell> {
  const response = await api.post(
    `/v1/products/${productId}/offer-funnels`,
    data
  );
  return response.data;
}

async function updateUpsell({
  productId,
  upsellId,
  data,
}: {
  productId: string;
  upsellId: string;
  data: Partial<Omit<Upsell, 'id'>>;
}): Promise<Upsell> {
  const response = await api.put(
    `/v1/products/${productId}/offer-funnels/${upsellId}`,
    data
  );
  return response.data;
}

async function deleteUpsell({
  productId,
  upsellId,
}: {
  productId: string;
  upsellId: string;
}): Promise<void> {
  await api.delete(`/v1/products/${productId}/offer-funnels/${upsellId}`);
}

export const UpsellService = {
  listUpsells,
  listUpsell,
  createUpsell,
  updateUpsell,
  deleteUpsell,
};
